import createDOMPurify from "dompurify";

/**
 * Allowlist aligned with `credible-loan-application-service` rich-text sanitization.
 * Display-only defense in depth.
 */
const RICH_TEXT_ALLOWED_TAGS = [
  "b",
  "i",
  "em",
  "strong",
  "u",
  "p",
  "br",
  "ul",
  "ol",
  "li",
  "span",
  "blockquote",
  "code",
  "pre",
];

const STYLE_ALLOWED_TAGS = new Set(["SPAN", "P"]);

const purify = createDOMPurify(window);

purify.addHook("uponSanitizeAttribute", (node, attribute) => {
  if (
    attribute.attrName === "style" &&
    !STYLE_ALLOWED_TAGS.has(node.nodeName)
  ) {
    attribute.keepAttr = false;
  }
});

export function sanitize(html: string): string {
  return purify.sanitize(html, {
    ALLOWED_TAGS: RICH_TEXT_ALLOWED_TAGS,
    ALLOWED_ATTR: ["style"],
  });
}
